'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { usePathname } from 'next/navigation';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { isActiveNavItem, isNavItemVisible } from '@src/components/TopNavV6/utils';
import { useSession } from '@src/hooks/useSession';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import { TopNavV6MobileFooter } from './TopNavV6MobileFooter';
export const TopNavV6MobileMenu = props => {
  const $ = _c(17);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    navItems,
    mobileSecondaryMenuItems
  } = props;
  const {
    setIsMobileMenuOpen,
    setSelectedThirdLevelMenu
  } = useTopNavV6();
  const {
    user
  } = useSession();
  const isLoggedIn = Boolean(user?.email);
  const pathname = usePathname();
  let t0;
  if ($[0] !== isLoggedIn || $[1] !== mobileSecondaryMenuItems || $[2] !== navItems || $[3] !== pathname || $[4] !== setIsMobileMenuOpen || $[5] !== setSelectedThirdLevelMenu || $[6] !== trackSelectNavCta || $[7] !== user) {
    const {
      edit
    } = getBuilderPreviewMode();
    const visibleNavItems = navItems?.filter(item => edit || isNavItemVisible(item.visibility, user)) ?? [];
    let t1;
    if ($[9] !== isLoggedIn || $[10] !== pathname) {
      t1 = item_0 => {
        if (item_0.isActive) {
          return true;
        }
        const url = isLoggedIn && item_0.authenticatedHref ? item_0.authenticatedHref : item_0.href;
        return url ? isActiveNavItem(url, pathname) : false;
      };
      $[9] = isLoggedIn;
      $[10] = pathname;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    const activeItem = visibleNavItems.find(t1);
    const mainMenuItems = activeItem ? [activeItem, ...visibleNavItems.filter(item_1 => item_1 !== activeItem)] : visibleNavItems;
    const activeItemChildren = activeItem?.navItems ?? [];
    t0 = <div className="flex flex-col gap-8 px-4 pb-8"><div className="flex flex-col">{mainMenuItems.map((item_2, index) => {
          const url_0 = isLoggedIn && item_2.authenticatedHref ? item_2.authenticatedHref : item_2.href;
          const isActive = item_2.isActive ?? (url_0 ? isActiveNavItem(url_0, pathname) : false);
          const hasChildren = (item_2.navItems?.length ?? 0) > 0;
          return <div key={`main-menu-${index}`} className={cn("flex flex-col", {
            "-mx-4 gap-4 bg-bodi-black-text bg-linear-to-r from-white/8 to-white/8 px-4": isActive,
            "pb-8": isActive && hasChildren
          })}><LocalizedLink href={url_0 ?? "#"} className={cn("flex w-full items-center justify-between border-b border-bodi-gray-dark px-0 py-3 text-left", isActive && "h-14")} onClick={() => {
              if (url_0) {
                trackSelectNavCta({
                  "cta url": url_0
                });
                setIsMobileMenuOpen(false);
              }
              item_2.onClick?.();
            }}><span className="text-heading-display-3 leading-8 text-white">{item_2.title}</span>{hasChildren && <div className="flex size-6 items-center justify-center"><ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></div>}</LocalizedLink>{isActive && activeItemChildren.length > 0 && <div className="flex flex-col gap-3 px-0">{activeItemChildren.map((childItem, childIndex) => {
                const hasMenu = Boolean(childItem.navItems ?? childItem.miniMenu);
                if (hasMenu) {
                  return <button key={`child-menu-${childIndex}`} className="flex w-full items-center justify-between" onClick={() => {
                    setSelectedThirdLevelMenu(childItem);
                    childItem.onClick?.();
                  }}><span className="text-body-base leading-6 font-medium text-white">{childItem.title}</span><div className="flex size-6 items-center justify-center"><ChevronRightIcon className="size-5 text-bodi-gray-medium" /></div></button>;
                }
                return <LocalizedLink key={`child-menu-${childIndex}`} href={childItem.href ?? "#"} className="flex w-full items-center justify-between" onClick={() => {
                  if (childItem.href) {
                    trackSelectNavCta({
                      "cta url": childItem.href
                    });
                    setIsMobileMenuOpen(false);
                  }
                  childItem.onClick?.();
                }}><span className="text-body-base leading-6 font-medium text-white">{childItem.title}</span></LocalizedLink>;
              })}</div>}</div>;
        })}</div>{mobileSecondaryMenuItems && mobileSecondaryMenuItems.length > 0 && <div className="flex flex-col gap-3">{mobileSecondaryMenuItems.filter(item_3 => edit || isNavItemVisible(item_3.visibility, user)).map((item_4, index_0) => item_4.href ? <LocalizedLink key={`secondary-menu-${index_0}`} href={item_4.href} className="flex w-full items-center justify-between" onClick={() => {
          trackSelectNavCta({
            "cta url": item_4.href
          });
          setIsMobileMenuOpen(false);
          item_4.onClick?.();
        }}><span className="text-body-base leading-6 font-medium text-bodi-gray-butters">{item_4.title}</span></LocalizedLink> : <button key={`secondary-menu-${index_0}`} className="flex w-full items-center justify-between" onClick={() => {
          setIsMobileMenuOpen(false);
          item_4.onClick?.();
        }}><span className="text-body-base leading-6 font-medium text-bodi-gray-butters">{item_4.title}</span></button>)}</div>}</div>;
    $[0] = isLoggedIn;
    $[1] = mobileSecondaryMenuItems;
    $[2] = navItems;
    $[3] = pathname;
    $[4] = setIsMobileMenuOpen;
    $[5] = setSelectedThirdLevelMenu;
    $[6] = trackSelectNavCta;
    $[7] = user;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[12] !== props) {
    t1 = <TopNavV6MobileFooter {...props} />;
    $[12] = props;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t0 || $[15] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
};